import { render, staticRenderFns } from "./instCheckBox.vue?vue&type=template&id=3684003a&scoped=true"
import script from "./instCheckBox.vue?vue&type=script&lang=js"
export * from "./instCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684003a",
  null
  
)

export default component.exports